///<reference path="./smart-mover.models.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import MeevoEventEmitter = Meevo.Components.Common.MeevoEventEmitter;

    export abstract class DataTemplateBase extends MeevoEventEmitter implements IDataTemplate {
        public get Title() {
            return this._title;
        }

        public set Title(value: string) {
            this._title = value || this._title;
        }

        get leafCollection() {
            return null;
        }

        get totalSelectedCount(): number {
            return this.collection.value.length;
        }

        get totalParentSelectedCount(): number {
            return null;
        }

        get valid(): boolean {
            return this.validation.filter((validation) => validation.valid).length === this.validation.length;
        }

        get hasSecurity(): boolean {
            return false;
        }

        get totalSelectedMessage() {
            return this._totalSelectedMessage;
        }

        set totalSelectedMessage(message: string) {
            this._totalSelectedMessage = message;

            this.totalSelectedMessageModel = new TextTotalSelected(message);
        }

        get totalParentSelectedMessage() {
            return this._totalParentSelectedMessage;
        }

        set totalParentSelectedMessage(message: string) {
            this._totalParentSelectedMessage = message;

            this.totalParentSelectedMessageModel = new TextTotalSelected(message);
        }

        protected filters: SmartMoverCollectionFilter[];
        protected smartMoverHidden: boolean;
        protected _totalSelectedMessage: string;
        protected _totalParentSelectedMessage: string;
        protected dataService: Meevo.Components.BaseClasses.IDataService;

        private _title: string;

        public abstract collection: ICollectionBase<any> | IApiCollection<any>;

        //#regionProperties
        public tips?: string[];

        /**
         * Used to show the number of element selected.
         * @example Total Items Selected: 123
         */
        public showMover: boolean;
        public abstract allSelectedLabel: string;
        public abstract title: string;
        public disabled: boolean;
        public showAllSelected: boolean;
        public voidIfAllSelected: boolean;
        public validation: ICustomValidation[];
        public totalSelectedMessageModel: ISmartMoverTextBase;
        public totalParentSelectedMessageModel: ISmartMoverTextBase;
        public showDescription: boolean;
        public description: string;

        //#regionendProperties

        constructor(public model: Dictionary<any>,
                    protected properties: string[],
                    protected criteria: Dictionary<any>) {
            super();

            this.showAllSelected = true;
            this.showMover = true;
            this.voidIfAllSelected = false;
            this.filters = [];
            this.validation = [];
            this.showDescription = false;

            for (const property of properties) {
                if (model && !model.hasOwnProperty(property)) {
                    model[property] = [];
                }
            }
        }

        public updateCollectionFromModel() {
            return null;
        }

        public reconnectLeafCollectionModel(model) {

        }

        fetch(dataService: Meevo.Components.BaseClasses.IDataService): ng.IPromise<any> | void {
            if (typeof (<IApiCollection<any>>this.collection).fetch === 'function') {
                return (<IApiCollection<any>>this.collection).fetch(dataService);
            }

            this.dataService = dataService;

            return;
        }

        onCriteriaUpdate(newCriteria: Dictionary<any>, $q: ng.IQService): ng.IPromise<any> {
            return $q.resolve();
        }

        setWatchers(scope: angular.IScope) {
            this.collection.setWatchers(scope);
        }

        onDestroy(): void {
        }

        setEvents(onFilterChanged: TFilterChangedFn): void {
            this.collection.on('ON_FETCH_START', () => {
                this.emit(ON_FETCH_START);
            });

            this.collection.on('all-collection-fetched', () => {
                this.emit(ON_FETCH_END);
            });

            if (onFilterChanged && this.filters instanceof Array) {
                for (const filter of this.filters) {
                    filter.on('change', (values) => {
                        onFilterChanged({ values });
                    });
                }
            }

            if (this.leafCollection) {
                this.leafCollection.on('all-collection-fetched', () => {
                    this.emit(ON_FETCH_END);
                })
            }
        }

        onHideToggle(hidden: boolean): void {
            this.smartMoverHidden = hidden;
        }

        updateConnectedModels(): void {
        }

        private _requiredValidator: RequiredValidation;

        protected updateRequiredValidator(required: boolean, collection) {
            if (required) {
                if (!this._requiredValidator) {
                    this._requiredValidator = new RequiredValidation(collection, '');
                }
                this.validation = this.validation.filter(validator => validator != this._requiredValidator);
                this.validation.push(this._requiredValidator);
            } else {
                this.validation = this.validation.filter(validator => validator != this._requiredValidator);
            }
        }
    }
}
